import { useId } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserLock } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "@/context/AuthContext";
import { useCrmHub } from "@/context/SignalRContext";
import { otherViewer } from "@/services/actionPresence";
export function ActionPresenceIcon({ actionId }: { actionId: string }) {
  const id = useId();
  const { session } = useAuth();
  const { actionPresence } = useCrmHub();
  const viewer = otherViewer(
    actionPresence,
    actionId,
    session?.userId ?? undefined,
  );
  if (!viewer) return null;
  const label = `Open in ${viewer.username}'s workspace`;
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={id}>{label}</Tooltip>}
    >
      <span
        tabIndex={0}
        role="img"
        aria-label={label}
        className="action-presence-icon ms-2"
      >
        <FontAwesomeIcon icon={faUserLock} />
      </span>
    </OverlayTrigger>
  );
}
